import React from 'react';
import { CloseOutlined, ArrowRightOutlined } from '@ant-design/icons';
import LockIcon from '../icons/LockIcon';

interface Props {
	// The single-line pitch shown next to the Pro badge, e.g.
	// "Pro users can star work orders with a note".
	message: string;
	onClose: () => void;
}

// Shared "upgrade to Pro" popover body used by gated Pro features (star-with-note,
// work-order labels). Renders the Pro badge + pitch and a "Contact Support to
// Upgrade" link that opens Intercom. Presentational — the caller owns the Popover
// and its open state.
const ProUpsellContent: React.FC<Props> = ({ message, onClose }) => {
	const handleContactSupport = () => {
		if (window.Intercom) {
			window.Intercom('startConversation', 'Interested in Supplier pro');
		}
	};

	return (
		<div
			onClick={(event) => event.stopPropagation()}
			onMouseDown={(event) => event.stopPropagation()}
			className="relative w-[368px] pb-2xs pt-2xs"
		>
			<CloseOutlined
				onClick={onClose}
				className="absolute right-0 top-2xs cursor-pointer text-sm text-character-secondary"
			/>
			<div className="flex flex-col gap-2xs">
				<div className="flex items-center gap-xs pb-xs pr-[22px]">
					<span className="footnoteregular inline-flex shrink-0 items-center gap-[3px] rounded-[100px] bg-teal-2 px-1.5 py-[1px] capitalize text-white">
						<LockIcon />
						<span>Pro</span>
					</span>
					<span className="bodyregular flex-1 text-character-primary">{message}</span>
				</div>
				<button
					type="button"
					onClick={handleContactSupport}
					className="bodymedium inline-flex w-fit cursor-pointer items-center gap-2xs border-0 bg-transparent p-0 text-cyan-7 underline"
				>
					<span>Contact Support to Upgrade</span>
					<ArrowRightOutlined className="text-[15px]" />
				</button>
			</div>
		</div>
	);
};

export default ProUpsellContent;
